import { useEffect, useState } from "react";

import Config from "../config";

const useFirebaseConfig = () => {
  const [info, setInfo] = useState({
    config:null,
    loading:true,
    error:null
  })

  useEffect(() => {
    const getConfig = async () => {
        const firebaseConfigUrl = Config.firebase.database.seachange_redirection_addresses;
        try {
          const response = await fetch(firebaseConfigUrl);
          const firebaseConfig = await response.json();

          setInfo({
            config: firebaseConfig,
            loading: false,
            error: null,
          });
        } catch (error) {

          setInfo({
            config: null,
            loading: false,
            error: error,
          });

          console.error('Error getting Firebase config:', error);
        }
    };

    getConfig();
  }, []);

  return [info.config, info.error, info.loading];
};

export default useFirebaseConfig;


// WEBPACK FOOTER //
// ./src/js/hooks/useFirebaseConfig.js